import React from "react";
import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { ShowBoolean } from "../../../common/controls";
import {
  useSnapshotExtension,
  useSnapshotExtensionTop,
} from "../../../common/controls";
import { FormControl } from "@mui/material";

type PublisherRepresentativeViewProps = {
  snapshotData: any;
  // Propagated from the top-level snapshot view so nested tables can resolve
  // the snapshot-scoped file-download endpoint (/<snapshotEntityName>.data/
  // <snapshotRecordId>/<fileUuid>). Both are optional at the type level but
  // required at runtime for the download / view affordances to work.
  snapshotEntityName?: string;
  snapshotRecordId?: string;
};

export const PublisherRepresentativeView: React.FC<
  PublisherRepresentativeViewProps
> = ({ snapshotData }) => {
  const { langStore } = useRootStore();
  const renderExtensionTop = useSnapshotExtensionTop("PublisherRepresentative");
  const renderExtension = useSnapshotExtension("PublisherRepresentative");

  return (
    <>
      {renderExtensionTop ? renderExtensionTop(snapshotData) : null}
      <FormControl fullWidth>
        <ShowMultiLine
          label={langStore.PublisherRepresentativeNameLabel}
          value={String(snapshotData?.name ?? "")}
        />
        <ShowMultiLine
          label={langStore.PublisherRepresentativeRoleLabel}
          value={String(snapshotData?.role ?? "")}
        />
        <ShowMultiLine
          label={langStore.PublisherRepresentativeEmailLabel}
          value={String(snapshotData?.email ?? "")}
        />
        <ShowMultiLine
          label={langStore.PublisherRepresentativePhoneLabel}
          value={String(snapshotData?.phone ?? "")}
        />
        <ShowBoolean
          label={langStore.PublisherRepresentativeIsSignerLabel}
          value={snapshotData?.isSigner ?? false}
        />
      </FormControl>
      {renderExtension ? renderExtension(snapshotData) : null}
    </>
  );
};
